import { useCallback } from 'react'

import { COMMON } from '@brickup/shared/locales/de/common'
import { extractErrorMessage } from '@/api/extract-error-message'
import { SnackbarType } from '@/components/Snackbar'
import { useSnackbar } from '@/hooks/use-snackbar'

/**
 * Shared shape for react-query `onError` handlers: reuses `extractErrorMessage`
 * (which already resolves structured `{code, ...}` bodies to German text) and
 * shows an ERROR snackbar. Pass this to any mutation's `onError` slot instead
 * of inlining the same three-liner per file.
 *
 * The fallback is what the snackbar says when the server sent no message of
 * its own; a write that has no more specific wording than "could not be
 * saved" leaves it off.
 */
export function useMutationErrorSnackbar() {
  const addSnackbar = useSnackbar()
  return useCallback(
    (err: unknown, fallback: string = COMMON.errors.saveFailed) =>
      addSnackbar({
        title: extractErrorMessage(err, fallback),
        type: SnackbarType.ERROR,
      }),
    [addSnackbar],
  )
}
